import moment from "moment";
import * as Yup from "yup";
let removeSpecialChars = (value) => {
  // Define your regex pattern to match special characters
  const regex = /[!@#$%^&*(),.?":{}|<>]/g;
  // Remove special characters from the value
  return value.replace(regex, "");
};

export const YUPValidations = Yup.object().shape({
  receiverName: Yup.string()
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces")
    .matches(/^[a-zA-Z ]+$/, "Username must contain only letters")
    .required("Receiver's name is required"),
  // isFullPayment:Yup.boolean().oneOf([true], 'Checkbox must be checked').required('Checkbox is required'),
  bankAccountNumber: Yup.string()
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces")
    .matches(
      /^[0-9a-zA-Z]+$/,
      "Bank account number must contain only numbers and letters"
    )
    .required("Bank account number is required"),
  // utrNumber: Yup.string()
  //   .matches(
  //     /^[0-9a-zA-Z]+$/,
  //     "UTR number must contain only numbers and letters"
  //   )
  //   .required("UTR number is required"),
  utrNumber: Yup.string()
    .nullable()
    .required("Please enter UTR number")
    .transform((value) => (value === null ? "" : value)),

  // paymentDate: Yup.date()
  //   .nullable()
  //   .required("Payment date is required")
  //   .transform((value) => (value === null ? "" : value)),
  // .max(new Date(), 'Date cannot be in the future'),

  paymentDate: Yup.date()
    .nullable()
    .required("Payment date is required")
    .typeError("Invalid date format") // This makes sure non-date values are caught
    .transform((value, originalValue) => (originalValue === "" ? null : value)),

  amountPaid: Yup.number()
    .moreThan(0, "Amount must be greater than 0")
    //   .matches(
    //     /^[0-9.]+$/,
    //     "Amount must contain only numbers "
    //   )
    .required("Amount is required"),
  ifscCode: Yup.string()
    .matches(/^[0-9a-zA-Z]+$/, "IFSC must contain only numbers and letters")
    .required("IFSC code is required"),
  bankName: Yup.string()
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces")
    .matches(/^[a-zA-Z ]+$/, "Bank name must contain only letters")
    .required("Bank name is required"),
});
export const funnelCard = [
  {
    header: "Total Payout",
    img: "../images/rupee-indian.png",
    value: "totalPayouts",
  },
  {
    header: "Total Providers",
    img: "../images/totalProvider.png",
    value: "totalProviders",
  },
  {
    header: "Payout Appointments",
    // header: "App Payouts Appt.",
    img: "../images/totalAppointment.png",
    value: "totalApppointments",
  },
  {
    header: "Unsuccessful Appt.",
    img: "../images/unsuccessfulAppointment.png",
    value: "unSuccessfullAppointments",
  },
  {
    header: "Closed Appointments",
    img: "../images/unsuccessfulAppointment.png",
    value: "totalCloseAppointments",
  },
];

export const initialFilterState = {
  providerIds: "",
  month: null,
  year: moment().year().toString(),
  clients: [],
  BusinessType: "CBU",
  SortDirection: "DESC",
  page: 1,
  rows: 10,
  caseNo: "",
  requestStatusId: 0,
};
export const initialFilterStates = {
  page: 1,
  rows: 10,
  Butype:"All",
  UserId: 2013,
  StartDate: "2024-04-01T00:00:00",
  EndDate:"2025-05-01T23:59:59",
  ProviderIds:"",
};
export const initialFilterStateForInvoiceGeneration = {
  page: 1,
  rows: 10,
  sortDirection: "DESC",
  buType: "CBU",
  month: null,
  year: moment().year().toString(),
  chainId: 0,
  providerId: 0,
  caseNo: "",
  invoiceNo: "",
  isExportToExcel: false,
  caseNo: null,
};

export const initialFilterStateForPayable = {
  providerIds: "",
  month: null,
  // year: null,
  year: moment().year().toString(),
  clients: [],
  BusinessType: "CBU",
  SortDirection: "DESC",
  page: 1,
  rows: 10,
};

export const formattedDate = (ele) => {
  const options = { month: "long", year: "numeric" };
  const date = new Date(ele);
  const formattedDate = date.toLocaleDateString("en-US", options);
  return formattedDate;
};

export const TotalProveiderMonth = (year, month) => {
  const date = new Date(year, month - 1, 1);
  const formattedDate = date.toLocaleString("default", {
    month: "short",
    year: "numeric",
  });
  return formattedDate;
};

export const initSendToQc = {
  year: null,
  month: null,
  remarks: "",
  providerIds: [],
  appointmentIds: [],
  qcType: null,
};

export const initialFilterPayout = {
  page: 1,
  rows: 10,
  Butype:"All",
  UserId: 2013,
  StartDate: "2025-04-01T00:00:00",
  EndDate:"2026-03-01T00:00:00",
  ProviderIds:"",
  RpTy: "S"
};